import { Fragment, useState } from 'react';
import { Page } from '../theme/elements/Page';
import { Box, Stack, Typography, Tab, Tabs } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { selectTranslations } from 'state/reducers/translation.reducers';
import { permissionEnums } from 'constants/permission.constants';
import { hasPermission } from 'components/AuthorizationComponent';
import { CountriesTable } from 'sections/CountriesManagement/CountriesTable';
import { getCountries } from 'state/reducers/global.reducer';
import { TabPanel } from 'sections/NewAccounts/Pending';
import { FormHeader3 } from 'theme/elements/Headers';
import _ from 'lodash';
import { ManageTable } from 'sections/CustomerRelationsManagement/ManageTable';
import { relationsTypes } from 'constants/customer-account.constants';
import { getAltshulerEmployees } from 'state/reducers/company.reducers';

export const CustomerRelationsManagementApp = () => {
	const t = useAppSelector(selectTranslations);
	const prefix = 'page.customer_relations_management.';
	const relations = useAppSelector(getAltshulerEmployees());
	const [tab, setTab] = useState(0);
	const handleChange = (event: React.SyntheticEvent, newValue: number) => {
		setTab(newValue);
	};

	return (
		<Fragment>
			<Page>
				<>
					<Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
						<Tabs value={tab} onChange={handleChange} aria-label="basic tabs example">
							{_.values(relationsTypes).map((type: string, index: number) => (
								<Tab key={index} label={t(`${prefix}tab.${type}.title`)} />
							))}
						</Tabs>
					</Box>
					{_.values(relationsTypes).map((type: relationsTypes, index: number) => {
						return (
							<TabPanel value={tab} index={index} key={index}>
								<ManageTable
									data={_.get(relations, type, [])}
									type={type}
									key={index}
									boUsers={relations?.boUsers}
								/>
							</TabPanel>
						);
					})}
				</>
			</Page>
		</Fragment>
	);
};
